export default function() {

  if (localStorage.getItem('settings') === null) return null;

  return JSON.parse(localStorage.getItem('settings'));
}
